<template>
    <div class="report-mb template2">
        <div
            class="data_container"
            v-show="showMarketReportData || showMarketComing"
        >
            <div class="board_container">
                <!-- card  the list  start -->
                <div class="board">
                    <Swiper class="slide_container">
                        <Slide>
                            <board-mb
                                :params="soldListing"
                                :hasRecentSold="hasRecentSold"
                            ></board-mb>
                        </Slide>
                        <Slide>
                            <board-mb
                                :params="avgSalePrice"
                                :hasRecentSold="hasRecentSold"
                            ></board-mb>
                        </Slide>
                        <Slide>
                            <board-mb
                                :params="avgDaysOnMarket"
                                :hasRecentSold="hasRecentSold"
                            ></board-mb>
                        </Slide>
                    </Swiper>
                </div>
                <!-- card  the list  end -->
                <div
                    class="loading_container"
                    v-show="showMarketReportLoading || showMarketComing"
                >
                    <Loading />
                </div>
            </div>
        </div>
        <div class="location_tips_container" v-show="showMarketNoLocation">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v2-img-no-market@2x.png"
                alt
            />
            <div class="desc">
                {{ $t('md-snapshot-search.pleaseInputAValid') }}
            </div>
        </div>
        <div class="no_data" v-show="showMarketNoData">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v2-img-no-market@2x.png"
                alt
            />
            <div class="desc">
                {{ noDataText }}
            </div>
        </div>
    </div>
</template>

<script>


import { mapState } from '@/store/helpers';


import Loading from '../../../../../components/loading';
import BoardMb from '../board/mobile';

import MoreBtnCommon from '../../../_mixins/more-btn/common';
import { Swiper, SwiperSlide } from '@/common/swiper';

export default {
    name: 'report-mb',
    components: {
        'board-mb': BoardMb,
        Loading,
        Swiper,
        Slide: SwiperSlide
    },
    data: function() {
        return {
        };
    },
    mixins: [MoreBtnCommon],
    computed: {
        ...mapState({
            "showMarketReportData": "showMarketReportData",
            "showMarketReportLoading": "showMarketReportLoading",
            "showMarketNoLocation": "showMarketNoLocation",
            "showMarketComing": "showMarketComing",
            "showMarketNoData": "showMarketNoData"
        }),
        hasRecentSold() {
            return this.soldListing?.status !== 3;
        }
    },
    props: {
        soldListing: {
            required: true
        },
        avgSalePrice: {
            required: true
        },
        avgDaysOnMarket: {
            required: true
        }
    }
};
</script>

<style lang="scss">
.report-mb.template2 {
    /*  Layout related  start */
    height: 250px;
    display: flex;
    align-items: center;
    .data_container {
        width: 100%;
        .board_container {
            width: 100%;
            padding-left: 20px;
            box-sizing: border-box;
            overflow: hidden;
            position: relative;
            .board {
                display: flex;
                width: 100%;
            }
            .loading_container {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                z-index: var(--level-low);
                background: rgba(255, 255, 255, 0.6);
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
        /*  Layout related  end */
        .more_container {
            padding: 0 20px;
            padding-top: 0.1px;
            .more {
                margin-top: 40px;
                width: 100%;
                height: 40px;
                border-radius: 2px;
                background-color: var(--color-theme);
                font-size: 16px;
                font-weight: 600;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }

    .coming_container,
    .location_tips_container,
    .no_data {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .pic {
            width: 240px;
            height: 100px;
        }
        .desc {
            margin-top: 20px;
            font-size: 16px;
            padding: 0 20px;
            text-align: center;
            color: var(--color-holder);
        }
    }
    .slide_container {
        display: flex;
    }
    .swiper {
        width: 100%;
        .swiper-slide {
            width: 350px;
        }
    }
    .more {
        p {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>
